module.exports = "https://static.wagwalking.com/_next/static/images/pet-1-8a8b507d9835d68987cf5c9dfd74e83b.png";